import { JOBSEARCH_HISTORY_LOADED } from '../../actions/jobsearch'
import * as h2Api from '../../h2Api'

const initialState = {
  history: [],
  recommendations: []
}
const data = (state = initialState, action) => {
  switch (action.type) {
    case JOBSEARCH_HISTORY_LOADED:
      if (action.restCall.status === h2Api.REST_CALL_STATUS.RECEIVED) {
        console.log(action.restCall.result)

        return {
          ...state,
          ...action.restCall.result
        }
      }

      return state

    default:
      return state
  }
}

export default data
